
import React, { Component } from 'react';
import Proptypes from 'prop-types';
import CaretIcon from './svg/CaretIcon';
import SportingLifeLogo from './svg/SportingLifeLogo';
import BurgerIcon from './svg/BurgerIcon';
import { IndexLink } from 'react-router';


class MainHeader extends Component {
    
    static propTypes = {
        path:                   Proptypes.string.isRequired,
        isLoggedIn:             Proptypes.bool.isRequired,
        featureStyleClasses:    Proptypes.array.isRequired,
        backButtonAction:       Proptypes.func.isRequired,
        toggleMenuAction:       Proptypes.func.isRequired,
        isMenuClosed:           Proptypes.bool.isRequired,
        children:               Proptypes.object
    }

    isRootPath(path) {
        return '/' === path;
    }

    getLogoClasses() {
        return [
            (this.isRootPath(this.props.path) ? "main-menu-logo" : "main-menu-logo-with-back"),
            (this.props.isLoggedIn ? "logged-in" : "logged-out"),
            ...this.props.featureStyleClasses
        ].join(' ');
    }

    handlerMenuClick = (e) => {
        
        this.props.toggleMenuAction(e)
    }

    render() {
        return (
            <header id="header-logo">
                {!this.isRootPath(this.props.path) &&
                <div className="main-back-icon">
                    <button id="back-button" onClick={this.props.backButtonAction}>
                        <CaretIcon type="line" direction="left"/>
                    </button>
                </div>
                }
                <span className={this.getLogoClasses()}>
                    <IndexLink to="/" className="svg-fix">
                        <SportingLifeLogo/>
                    </IndexLink>
                </span>
                { this.props.children }
                <div className="main-menu-icon">
                    <button id="main-menu" onClick={this.handlerMenuClick}>
                        <BurgerIcon title="Menu" close={this.props.isMenuClosed}/>
                    </button>
                </div>
            </header>
        );
    }
}

export default MainHeader;



// WEBPACK FOOTER //
// ./modules/Common/components/MainHeader.js